
		
				/** @jsx CsApp3.Core.createPureElement */
				/** @jsxFrag CsApp3.Core.createPureFragment */
			
		{
		
			let appNs = CsApp3.get('elinkerApps/DefaultWebTemplate');
			
			
		appNs.component('body.PreHeaderA', class extends CsApp3.Core.PureComponent {
			
			constructor(props){
			
				super(props);
				
				this.parent = props._parent_component;
				this.appFrame = props._cs_config.appFrame;
				
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
			
				return(
					<>
					{
					<div  {...{'id': 'pre_header'}} className={ this.utils.makeclass('', this.props.pre_header.public_id, '') } >{this.utils.ent_decode(this.props.pre_header.html)}</div>
					}
					</>
				);
				
			} 
			
		});
		
		appNs.component('body.PreHeaderB', class extends CsApp3.Core.PureComponent {
			
			constructor(props){
			
				super(props);
				
				this.parent = props._parent_component;
				this.appFrame = props._cs_config.appFrame;
				
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
			
				return(
					<>
					{
					<div  {...{'id': 'pre_header'}} >
			{' '}<div  {...{'id': 'pre_header_contents'}} >
				{' '}{
						
							(() => {
							
								if((this.props.pre_header.html == null &&       this.props.custom_params.header_mode != 'normal_mode' &&       this.props.custom_params.header_mode != 'none')){
								
									return(<img {...{'src': this.utils.prefixize_url( this.props.custom_params.logo1 )} } ></img>);
									
								} else { 
								
									return null;
									
								}
								
							})()
							
						}
			{' '}</div>
		{' '}</div>
					}
					</>
				);
				
			} 
			
		});
		
		appNs.component('body.SubMenuButton', class extends CsApp3.Core.PureComponent {
			
			constructor(props){
			
				super(props);
				
				this.parent = props._parent_component;
				this.appFrame = props._cs_config.appFrame;
				
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
			
				return(
					<>
					{
					<li >
											{' '}<a {...{'href': this.utils.prefixize_url( this.props.sub_page.href )} } {...{'className': ((this.props.sub_page.click_behaviour ?? null) != '1' ? ' ax' : '') } } >
												{' '}<div ><h3 >{this.utils.ent_decode(this.props.sub_page.name)}</h3></div>
											{' '}</a>
											{' '}{
						
							(() => {
							
								if((this.props.sub_page.list)){
								
									return(<ul >{ 
						Object.entries(this.props.sub_page.list).map((sub_page2) => {   
							return (<> { <appNs.components.body.SubMenuButton sub_page={ sub_page2[1] } _cs_config={ this.props._cs_config } _parent_component={ this } /> } </>);
						})
					}</ul>);
									
								} else { 
								
									return null;
									
								}
								
							})()
							
						}
										{' '}</li>
					}
					</>
				);
				
			} 
			
		});
		
		appNs.component('body.MenuButton', class extends CsApp3.Core.PureComponent {
			
			constructor(props){
			
				super(props);
				
				this.parent = props._parent_component;
				this.appFrame = props._cs_config.appFrame;
				
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
			
				return(
					<>
					{
					<li >
									{' '}<a {...{'href': this.utils.prefixize_url( this.props.page.href )} } {...{'className': ((this.props.page.click_behaviour ?? null) != '1' ? ' ax' : '') } } >
										{' '}<div ><h2 >{this.utils.ent_decode(this.props.page.name)}</h2></div>
									{' '}</a>
									{' '}<ul >{ 
						Object.entries(this.props.page.list).map((sub_page) => {   
							return (<> { 
				
					(() => {
					
						if(sub_page[1].navbar_include){
						
							return(<>{ <appNs.components.body.SubMenuButton sub_page={ sub_page[1] } _cs_config={ this.props._cs_config } _parent_component={ this } /> }</>);
							
						} else { 
						
							return null;
							
						}
						
					})()
					
				 } </>);
						})
					}</ul>
								{' '}</li>
					}
					</>
				);
				
			} 
			
		});
		
		appNs.component('body.Content', class extends CsApp3.Core.PureComponent {
			
			constructor(props){
			
				super(props);
				
				this.parent = props._parent_component;
				this.appFrame = props._cs_config.appFrame;
				
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
			
				return(
					<>
					{
					<section className={ this.utils.makeclass('content-body', this.props.content.public_id, '') } >{this.utils.ent_decode(this.props.content.html)}</section>
					}
					</>
				);
				
			} 
			
		});
		
		appNs.component('body.Contents', class extends CsApp3.Core.PureComponent {
			
			constructor(props){
			
				super(props);
				
				this.parent = props._parent_component;
				this.appFrame = props._cs_config.appFrame;
				
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
			
				return(
					<>
					{
					<div  {...{'id': 'data'}} >{ 
						Object.entries(this.props.contents).map((content) => {   
							return (<> { <appNs.components.body.Content content={ content[1] } _cs_config={ this.props._cs_config } _parent_component={ this } /> } </>);
						})
					}</div>
					}
					</>
				);
				
			} 
			
		});
		
		appNs.component('body.Renderer', class extends CsApp3.Core.PureComponent {
		
			constructor(props){
			
				super(props);
				
				this.appFrame = props._cs_config.appFrame;
			
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
				return(
					<>
					<div  {...{'id': 'loading_overlay'}}  {...{'data-cs-app-ns': 'elinkerApps/DefaultWebTemplate'}} ></div> 
{' '}<div  {...{'id': 'body'}}  {...{'data-cs-app-ns': 'elinkerApps/DefaultWebTemplate'}} > 
	{' '}{
						
							(() => {
							
								if(((this.props.$.header_mode ?? null) != 'none')){
								
									return(<div  {...{'id': 'header'}} className={ this.utils.makeclass('XpreHeader_mode Xrtl Xheader_tools_enabled', (this.props.$.header_mode ??'') + ' ' + (this.props.$.header_align ?? '') + ' ' + (this.props.$.header_toolbar ?? ''), '') } >
		{' '}<div  {...{'className': 'header_toolbar_placeholder header_toolbar_height'}} >
			{' '}<div  {...{'className': 'header_toolbar_wr header_toolbar_height'}} >
				{' '}{
						
							(() => {
							
								if(((this.props.$.header_toolbar ?? false) && this.props.$.header_toolbar != 'header_tools_disabled')){
								
									return(<div  {...{'id': 'header_toolbar'}} >{<div >
						{' '}<a {...{'href': this.utils.prefixize_url('/elc/zona-usuarios/basket/')} } className={ this.utils.makeclass('basket_link hyperlink_color', this.props.user.class, '') } >
							{' '}
						{' '}</a>
					{' '}</div>}{<div >
						{' '}<a {...{'href': this.utils.prefixize_url('/elc/zona-usuarios/')} } className={ this.utils.makeclass('login_link hyperlink_color', this.props.user.class, '') } >{this.utils.ent_decode(this.props.user.user_link)}</a>
					{' '}</div>}</div>);
									
								} else { 
								
									return null;
									
								}
								
							})()
							
						}
			{' '}</div>
		{' '}</div>
		{' '}{
						
							(() => {
							
								if(((this.props.$.header_mode ?? null) &&  this.props.$.header_mode != 'normal_mode' && this.props.$.header_mode != 'none')){
								
									return(<>{ CsApp3.Core.createPureElement(appNs.components.obj_get(pre_header.html ? 'body.PreHeaderA' : 'body.PreHeaderB'), { 'pre_header': this.props.pre_header ,'custom_params': this.props.$ , _cs_config: this.props._cs_config, _parent_component: this }) }</>);
									
								} else { 
								
									return null;
									
								}
								
							})()
							
						}
		{' '}<div  {...{'id': 'header_contents_wr'}} >
			{' '}<div  {...{'id': 'header_contents'}} >
				{' '}<div  {...{'id': 'h_contents'}} >
					{' '}<div  {...{'id': 'h_logo'}}  {...{'className': 'fade_img'}} >
						{' '}<div  {...{'id': 'h_logo_img_wr'}} >
							{' '}<img {...{'src': this.utils.prefixize_url( this.props.$.logo2 ?? 'data:,' )} } ></img>
						{' '}</div>
					{' '}</div>
					{' '}<div  {...{'id': 'h_buttons'}} >
						{' '}<input  {...{'id': 'menu_locker'}}  {...{'type': 'checkbox'}} ></input>
						{' '}<label  {...{'htmlFor': 'menu_locker'}} >{"\u2630"}</label>
						{' '}<nav  {...{'className': 'h_ul_wrapper'}} >
							{' '}<ul >{ 
						Object.entries(this.props.pages).map((page) => {   
							return (<> { 
				
					(() => {
					
						if(page[1].navbar_include){
						
							return(<>{ <appNs.components.body.MenuButton page={ page[1] } _cs_config={ this.props._cs_config } _parent_component={ this } /> }</>);
							
						} else { 
						
							return null;
							
						}
						
					})()
					
				 } </>);
						})
					}</ul>
						{' '}</nav>
					{' '}</div>
				{' '}</div>
			{' '}</div>
		{' '}</div>
	{' '}</div>);
									
								} else { 
								
									return null;
									
								}
								
							})()
							
						}
	{' '}<div  {...{'id': 'content'}} >
		{' '}<>{ CsApp3.Core.createPureElement(appNs.components.obj_get('body.Contents'), { 'contents': this.props.contents , _cs_config: this.props._cs_config, _parent_component: this }) }</>
	{' '}</div>
	{' '}<div  {...{'id': 'footer'}} >
		{' '}<img {...{'src': this.utils.prefixize_url('assets/body/logo2.png')} } {...{'style': this.utils.prefixize_style('display: none')} } ></img>
		{' '}{
						
							(() => {
							
								if((this.props.footer ?? false)){
								
									return(<section className={ this.utils.makeclass('content-body', this.props.footer.public_id, '') } >{this.utils.ent_decode(this.props.footer.html)}</section>);
									
								} else { 
								
									return null;
									
								}
								
							})()
							
						}
	{' '}</div>
{' '}</div>
					</>
				);
			} 
			
		});
		
			
		}